import { FormattedMessage } from 'react-intl'

import BasicPageFilterResults from 'features/common/ui/BasicPage/Partials/BasicPageFilterResults'

interface MapClearSearchProps {
  total: number
  search: string
  onClear: () => void
}

function MapsClearSearch({ total, search, onClear }: MapClearSearchProps) {
  return (
    <BasicPageFilterResults
      results={<FormattedMessage id="workflows.filters.title" values={{ elements: total, query: search }} />}
      linkLabel="clear-maps-search"
      linkAction={onClear}
    />
  )
}

export default MapsClearSearch
